import axios from 'axios';
import { isEmpty, map } from 'lodash-es';
import NP from 'number-precision';

import { SortOrder } from 'antd/es/table/interface';
import dayjs from 'dayjs';

export const formatTime = (text, tit) => {
  if (!text) return null;

  return tit.includes('时间')
    ? dayjs(text).format('YYYY-MM-DD HH:mm:ss')
    : dayjs(text).format('YYYY-MM-DD');
};

export const PreviewPdf = (url: any) => {
  if (!url) return;
  axios
    .get(url, {
      responseType: 'blob',
    })
    .then((resp) => {
      const blob = new Blob([resp.data], { type: 'application/pdf' });
      let URL = window.URL || window.webkitURL;
      window.open(URL.createObjectURL(blob));
    });
};

// 下载文件
// export const uploadFileUrl1 = (fileId: string) => {
//   const { getAccessToken } = useAuthService();
//   axios
//     .get(`/fileupload/GetFileInfoByIdAsync?fileId=${fileId}`, { headers: { Authorization: `Bearer ${getAccessToken()}` } })
//     .then((res) => {
//       if (!res?.data?.success) return message.error(res?.data?.message);
//       window.open(res?.data?.data?.url);
//     })
//     .catch((err) => {
//       message.error('下载失败');
//     });
// };

export const downloadFile = (response: any, fileName: string) => {
  // 处理导出文件下载
  if (response) {
    let resolvedName =
      fileName || `${new Date().toLocaleDateString('zh-CN')}.xlsx`;

    // 后端若返回 URL 编码文件名，下载前反复还原为可读中文
    for (let i = 0; i < 3; i += 1) {
      if (!/%[0-9a-fA-F]{2}/.test(resolvedName)) break;
      try {
        const decoded = decodeURIComponent(resolvedName.replace(/\+/g, '%20'));
        if (decoded === resolvedName) break;
        resolvedName = decoded;
      } catch {
        break;
      }
    }

    // 假设API返回的是文件URL或Blob
    if (typeof response === 'string' && response.startsWith('http')) {
      // 如果是URL，直接下载
      window.open(response, '_blank');
    } else if (response instanceof Blob) {
      // 如果是Blob，创建下载链接
      const url = window.URL.createObjectURL(response);
      const a = document.createElement('a');
      a.href = url;
      a.download = resolvedName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } else {
      throw new Error('下载失败');
    }
  }
};

// 分页参数
export const tableProps: any = {
  // options: false,
  size: 'small',
  search: false,
  scroll: { x: 'max-content' },
  // tableAlertRender: false,
  // locale:{
  //   emptyText: (<Empty description={false}/>),
  // },
  pagination: {
    showTotal: (total: number) => `共 ${total} 条`,
    defaultPageSize: 50,
    showQuickJumper: true,
    showSizeChanger: true,
  },
};

// 重置分页
export const resetPagination = (actionRef: any) => {
  // actionRef.current.setPageInfo({ current: 1 })
  // actionRef.current?.reload()
  // 刷新并清空,页码也会重置，
  actionRef?.current?.reloadAndRest();
};

// 按钮权限方法
export const hasPermission = (value: string[]) => {
  // @ts-ignore
  const userAuthorization =
    JSON.parse(localStorage.getItem('obas-userAuthorization')) || [];
  const authorization = map(
    userAuthorization,
    (item: { name: any }) => item.name,
  );
  if (!isEmpty(value)) {
    return authorization?.find((item) => {
      return value?.includes(item);
    });
  }
  return false;
};

// 格式化为千分位形式并保留2位小数
export const formatNumber = (number: number, num?: number) => {
  if (number === null || number === undefined) return '';
  num = num || 2;
  const formattedNumber = NP.strip(number); // 去除小数点后多余的0
  const formattedString = formattedNumber
    .toFixed(num)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return formattedString;
};

// 保留2位小数 并加上百分号
export const formatNumberPercentile = (number: number) => {
  if (number === null || number === undefined) return '';
  const formattedNumber = NP.strip(number); // 去除小数点后多余的0
  const formattedString = (formattedNumber * 100).toFixed(2) + '%';
  return formattedString;
};

export const handleAbacQuestionData = (data: any) => {
  const _a: any = [];
  window.abacQuestion?.forEach((v: any) => {
    _a.push({
      questionId: v.id,
      question: v.question,
      result: data.question[v.id],
    });
  });
  data.questionnaires = _a;
  delete data.question;
};

export const formatNumberWithCommasAndDecimals = (number: number) => {
  number = NP.strip(number); // 去除小数点后多余的0
  const units = ['', 'K', 'M'];
  const unitIndex = number >= 1000000 ? 2 : number >= 1000 ? 1 : 0;
  number =
    number >= 1000000
      ? number / 1000000
      : number >= 1000
      ? number / 1000
      : number;
  const formattedString = number
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${formattedString} ${units[unitIndex]}`;
};

//
export const formatMillennials = (number: number) => {
  const formattedNumber = NP.strip(number); // 去除小数点后多余的0
  const formattedString = `${formattedNumber}`.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ',',
  );
  return formattedString;
};

export const handleTableSort = (sort: Record<string, SortOrder>) => {
  // 将sort参数转换为API需要的格式，只返回第一个排序字段
  if (!sort || Object.keys(sort).length === 0) {
    return '';
  }

  // 获取第一个排序字段
  const [field, order] = Object.entries(sort)[0];
  return `${field} ${order === 'ascend' ? 'ASC' : 'DESC'}`;
};

// Narrow falsy values from a list and keep proper typing.
// Usage: filterByBoolean([1, 0, null, 2]) -> returns number[] with 0 and null removed.
export const filterByBoolean = <T>(list: ReadonlyArray<T>) => {
  // Exclude common falsy literal types from T for the return type.
  type Falsy = false | '' | 0 | null | undefined;
  return list.filter(Boolean) as Array<Exclude<T, Falsy>>;
};

/** 统一取接口返回/异常中的 message（兼容业务 reject 与 AxiosError） */
export const getApiMessage = (errorOrRes: any, fallback = '') => {
  const fromBody =
    errorOrRes?.data?.message ||
    errorOrRes?.response?.data?.message ||
    (typeof errorOrRes?.data === 'string' ? errorOrRes.data : undefined);
  // 成功响应体上的 message；AxiosError.message 多为状态码文案，不优先采用
  const fromRes =
    !(errorOrRes instanceof Error) && typeof errorOrRes?.message === 'string'
      ? errorOrRes.message
      : undefined;
  const msg = [fromBody, fromRes, fallback].find(
    (item) => typeof item === 'string' && item.trim(),
  );
  return (msg as string) || '';
};
